import { getTranslatedLabels } from '@/lib/translations'
import { getTemplate } from './templates'

interface ResumePreviewProps {
  data: any
  template: string
  language?: string
  color?: string
}

export default function ResumePreview({ data, template, language = 'en', color = 'blue' }: ResumePreviewProps) {
  const labels = getTranslatedLabels(language)

  // Get the template metadata from registry
  const templateMetadata = getTemplate(template)

  // If template not found, show error message
  if (!templateMetadata) {
    return (
      <div className="bg-white rounded-lg shadow-2xl border border-red-200 overflow-hidden">
        <div className="p-8 text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Template Not Found</h2>
          <p className="text-gray-600">
            The template "{template}" could not be found. Please select a different template.
          </p>
        </div>
      </div>
    )
  }

  // Render the selected template component
  const TemplateComponent = templateMetadata.component

  return <TemplateComponent data={data} labels={labels} language={language} color={color} />
}
